export default (password, passwordAgain) => {
    if (password == passwordAgain) {
        return true;
    }
};



// WEBPACK FOOTER //
// ./src/utils/validateAgainPassword.js